import React from 'react';
import clsx from 'clsx';

interface ContentInputFieldProps {
  fieldTitle: string;
  fieldTemplate?: 'inline' | 'default';
  field: React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

const CreateContentField: React.FC<ContentInputFieldProps> = React.memo(
  ({
    fieldTitle,
    field,
    fieldTemplate = 'default',
    disabled,
    error,
    helperText,
  }) => {
    return (
      <div
        className={clsx('row', {
          inline: fieldTemplate === 'inline',
          disabled,
          error,
        })}
      >
        <p className='fieldHeader'>{fieldTitle}</p>

        <div className='fieldWrapper'>{field}</div>

        {helperText && <span className='fieldHelperText'>{helperText}</span>}
      </div>
    );
  },
);

export default CreateContentField;
